/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitGetEntityLookAlikesAggQueries
 */
export interface MonitGetEntityLookAlikesAggQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityLookAlikesAggQueries
     */
    process_id?: string;
}

/**
 * Check if a given object implements the MonitGetEntityLookAlikesAggQueries interface.
 */
export function instanceOfMonitGetEntityLookAlikesAggQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityLookAlikesAggQueriesFromJSON(json: any): MonitGetEntityLookAlikesAggQueries {
    return MonitGetEntityLookAlikesAggQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityLookAlikesAggQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityLookAlikesAggQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
    };
}

export function MonitGetEntityLookAlikesAggQueriesToJSON(value?: MonitGetEntityLookAlikesAggQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
    };
}

